import React, { useRef, useState } from "react";
import { Form, Input, Button, message } from "antd";
import { useHistory } from "react-router-dom";
import AuthService from "../../Services/AuthService";
import { APP_ROUTES } from "../../PageRouting/approutes";
import { generateAesKey } from "../../utils/passwordEncrypt";
import Humanimg from "../../Assets/Images/Svg/Loglogo.svg";
import cytologo from "../../Assets/logo/Doxzon Logo.svg";
import { saveLoggedUser } from "../../Redux/actions/UserActions";
import { useDispatch } from "react-redux";

function MobileLogin() {
  const [form] = Form.useForm();
  const history = useHistory();
  const [userName, setUserName] = useState("");
  const [disable, setDisable] = useState(false);
  const [page, setPage] = useState("1");
  const inputRefs = useRef([]);
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const [timer, setTimer] = useState(0);
  const verifyformRef = useRef();
  const [invalid, setInvalid] = useState("");
  const inputsRef = useRef([]);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const dispatch = useDispatch();

  const handleGoDashboard = () => {
    history.push(APP_ROUTES.LOGINFORM);
  };

  const handleGetOTP = async () => {
    setDisable(true);
    const isValid = /^\d{10,}$/.test(userName);

    if (!isValid) {
      message.error("Enter valid mobile number");
      setDisable(false);
      return;
    }

    let payload1 = {
      userId: userName,
    };

    if (!payload1.userId) {
      message.error("please enter valid credentials to login");
      setDisable(false);
      return;
    }

    let tokenPayload = {
      userId: `U${userName}`,
      password: "NA",
    };

    try {
      let tokenResult = await AuthService.GetTokenForOTP(tokenPayload);
      sessionStorage.setItem("access_token", tokenResult.data.access_token);
      sessionStorage.setItem("refresh_token", tokenResult.data.refresh_token);

      let result = await AuthService.GenerateOTP(payload1);
      setPage("2");
      startResendTimer();
    } catch (error) {
      message.error(error?.response?.data.message || "error occured try again");
      setDisable(false);
    }
  };

  const startResendTimer = () => {
    setIsResendDisabled(true);
    setTimer(120);

    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setIsResendDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const formatTime = (seconds) => {
    const mins = String(Math.floor(seconds / 60)).padStart(2, "0");
    const secs = String(seconds % 60).padStart(2, "0");
    return `${mins}:${secs}`;
  };

  const handleVerifyOTP = async (e) => {
    setDisable(true);
    const enteredOtp = otp.join("");
    if (enteredOtp.length !== 6) {
      message.error("Please enter a 6-digit OTP.");
      setDisable(false);
      return;
    }
    const encryptPassword = generateAesKey(enteredOtp);
    let verifyPayload = {
      numVal: encryptPassword,
      userId: userName,
    };
    try {
      const response = await AuthService.VerifyOTP(verifyPayload);
      if (!response.data.message) {
        if (
          response.data.user.rolecode !== "SUPERADMIN" &&
          response.data.user.userType == "P"
        ) {
          history.push(APP_ROUTES.DASHBOARD);
          message.success(
            `Welcome ${response.data.user.firstName} ${response.data.user.lastName}`
          );
          sessionStorage.setItem("login_result", JSON.stringify(response.data));
          dispatch(saveLoggedUser(response.data));
          sessionStorage.setItem(
            "defaultClinic",
            response?.data?.user?.clinic_Id
          );
        } else {
          message.error("Invalid Credentials, verify and try again");
          setDisable(false);
        }
      } else {
        message.error(response.data.message);
        setDisable(false);
      }
    } catch (e) {
      message.error(e.response.data.message);
      setInvalid(e.response.data.message);
      return;
    }
  };

  const handleResendOTP = async () => {
    setDisable(true);

    let payload1 = {
      userId: userName,
    };

    try {
      let result = await AuthService.GenerateOTP(payload1);
      startResendTimer();
      setInvalid("");
    } catch (error) {
      message.error(error.response.data.message);
      setDisable(false);
    }
  };

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) {
        inputsRef.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handleKeyPress = (e) => {
    const allowedKeys = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
    ];
    if (!allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="w-full max-w-md border rounded-xl border-[#D0D0D0] p-6 bg-white">
        {page == "1" ? (
          <div className="w-full">
            <div className="mt-4 flex flex-col gap-1 justify-center items-center ">
              <img src={cytologo} alt="logo" className="w-32 h-10" />
              <span className="text-[12px]">Technology for Health</span>
            </div>

            <div className="text-center mt-3 mb-4 text-[#189FAA] text-[16px] font-semibold ">
              Doctor
            </div>
            <Form
              name="basic"
              layout="vertical"
              autoComplete="off"
              form={form}
              ref={verifyformRef}
              onFinish={handleGetOTP}
            >
              <Form.Item name="userId">
                <Input
                  id="userName"
                  value={userName}
                  onKeyDown={handleKeyPress}
                  onChange={(e) => setUserName(e.target.value)}
                  placeholder=" "
                  className="w-full   rounded-lg pl-9 p-3  focus:border-[#189FAA] peer focus:ring-0"
                  style={{ background: "none" }}
                />
                <img
                  src={Humanimg}
                  alt="user"
                  className="absolute left-2 top-2 w-6 h-6 object-contain"
                />

                <label
                  htmlFor="userName"
                  className="absolute left-8 rounded-sm -top-2 text-gray-400 text-[12px] transition-all 
    peer-placeholder-shown:top-3 peer-placeholder-shown:text-[13px] peer-placeholder-shown:text-gray-400 
    peer-focus:-top-2 peer-focus:text-[12px] peer-focus:text-[#189FAA] bg-white px-1"
                >
                  Enter Registered Mobile Number
                </label>
              </Form.Item>

              <Form.Item>
                <button
                  htmlType="submit"
                  type="primary"
                  className="w-full font-semibold text-white rounded-md inline-block mt-2 mb-5 h-10 bg-brand-primaryColor"
                  disabled={disable}
                >
                  Get OTP
                </button>
                <div className="flex justify-center items-center mt-0 mb-2">
                  <p
                    onClick={() => history.push(APP_ROUTES.LOGINFORM)}
                    className=" text-brand-primaryColor mt-0 text-sm cursor-pointer mb-0"
                  >
                    Login with Email
                  </p>
                </div>
              </Form.Item>
            </Form>
          </div>
        ) : (
          <div className="my-">
            <div className="mt-0 flex justify-center">
              <img src={cytologo} alt="logo" className="w-24 h-10" />
            </div>
            <div className="my-2 text-center">
              <label className="md:text-sm text-[#414141] text-base flex justify-center font-sans font-semibold">
                Verify Your Account{" "}
              </label>
              <label className="block text-[#848484] mt-2 ">
                We sent your code on you mentioned
              </label>
              <label className="block text-[#848484]">mobile number</label>
            </div>

            <Form ref={verifyformRef}>
              <div className="flex justify-center gap-2 mb-5">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength="1"
                    inputMode="numeric"
                    value={digit}
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    ref={(el) => (inputsRef.current[index] = el)}
                    className="w-[40px] h-[40px] text-center text-[20px] rounded-md border border-[#189FAA]"
                  />
                ))}
              </div>
              <div
                className={`${invalid ? "justify-between flex flex-col" : "flex"
                  }`}
              >
                <p className="text-red-500 font-xs">{invalid}</p>
                <button
                  htmlType="submit"
                  type="primary"
                  className="font-semibold p-1 border text-white rounded-md inline-block mb-3"
                  onClick={handleResendOTP}
                  disabled={isResendDisabled}
                >
                  {timer > 0 ? (
                    <span>Resend OTP in {formatTime(timer)}</span>
                  ) : (
                    <span>Resend OTP</span>
                  )}
                </button>
              </div>
              <button
                className="w-full font-semibold  text-white rounded-md inline-block mt-2 mb-5 h-10 bg-brand-primaryColor"
                onClick={handleVerifyOTP}
              >
                Verify
              </button>
              <p
                className="flex justify-center text-base font-sans cursor-pointer font-normal text-[#189FAA]"
                onClick={handleGoDashboard}
              >
                Login with password
              </p>
            </Form>
          </div>
        )}
      </div>
    </div>
  );
}

export default MobileLogin;
